
import '@/assets/scss/index.scss'
import dayjs from 'dayjs'
import _ from 'lodash'

import TabCmp from '@/components/ms/TabCmp.vue'
import { commonfunc } from '~/mixin/common'
import { cmnMsStr } from '~/mixin/ms/msMixin'
import { pdMixin } from '@/mixin/pd/pdMixin'
import mbUtils from '~/scriptData/mb/utils/mbUtils'
import ScrMbc011502 from '@/pages/mb/mbc/SCR_MBC_0115_02.vue'
// import ScrMbc011701 from '@/pages/mb/mbc/SCR_MBC_0117_01.vue'
import ScrMsg0021 from '~/pages/ms/msg/SCR_MSG_0021.vue'
import AddressCard from '@/components/common/address/AddressCard.vue'
import AddPickupStr from '@/components/common/modal/AddPickupStr.vue'
import StoreUnitCard from '@/components/common/address/StoreUnitCard.vue'

export default {
  components: {
    TabCmp,
    AddressCard,
    AddPickupStr,
    ScrMbc011502,
    // ScrMbc011701,
    ScrMsg0021,
    StoreUnitCard
  },
  mixins: [commonfunc, cmnMsStr, pdMixin, mbUtils],
  data () {
    return {
      outerVisible: false,
      srcComp: '',
      tabIdx: '1',
      tabsDataSub: [ // 탭 data
        {
          id: '1',
          title: '배송지 관리',
          name: '1'
        },
        {
          id: '2',
          title: '픽업매장 관리',
          name: '2'
        }
      ],
      list: [],
      mbMngNo: '',
      posiStrInfoList: [],
      posiQuickStrInfoList: [],
      recentDvya: {},
      srchForm: {
        mbMngNo: this.$store.getters['session/getMbMngNo'],
        keyword: '',
        srchYn: 'N',

        geolocationAgrYn: 'N',
        curLttd: 0.0,
        curLitd: 0.0,

        currentPage: 1,
        pageSize: 100
      },
      pkupStr: [],
      strList: [],
      pkupStrList: [],
      addStoreVisible: false,
    }
  },
  watch: {
    outerVisible (data) {
      if (data) {
        // 위치정보수집동의여부 조회
        this.selGeolocationAgrYn()
        this.dvyaList()
        // 기본픽업매장 조회
        // this.selPkupStrList()
        // 최근픽업매장조회
        this.selRecentDvya()
      } else {
        this.srchForm.keyword = ''
        this.strList = []
        this.geoData.flag = null
        if (this.$refs.tab) {
          this.tabIdx = '1'
          this.$refs.tab.changeIndex(this.tabIdx)
        }
        this.$emit('closed')
      }
    },
    tabIdx (data) {
      this.selRecentDvya()
    },
    'geoData.flag' (val) {
      this.srchForm.geolocationAgrYn = this.geoData.geolocationAgrYn
      this.srchForm.curLttd = this.geoData.strLttd
      this.srchForm.curLitd = this.geoData.strLitd

      this.selPkupStrList()
    },
  },
  methods: {
    popupCloseCallback () {
      this.$refs.mbc011502.outerVisible = false
    },
    strDtl (strCd) {
      this.$refs.msg0021.strCd = strCd
      this.$refs.msg0021.outerVisible = true
    },
    dvyaList (updForm) {
      this.$AxiosBuilder
        .data()
        .build()
        .post('/mb/mbc/selDvya')
        .then((res) => {
          console.log(res)
          if (this.isNotEmpty(res.data.data)) {
            this.list = res.data.data
            this.selIdx = 0
            if (this.list.length > 0) {
              const zipList = {
                zipList: this.list.map(row => row.addrZip)
              }
              this.selPosiStrInfoList(zipList) // 거점매장리스트 조회
              this.selPosiQuickStrInfoList(zipList) // 오늘배송매장리스트 조회
            }
          }
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        })
    },
    dvyaAdit () {
      if (this.list.length >= 20) {
        this.$alert(this.$t('SM.MAX_SAVE_DELIVERY'))
      } else {
        if (this.list.length === 0) {
          this.$refs.mbc011502.bassDvyaYnDisabled = true
        } else {
          // 2024.01.17. 기본배송지가 있는 상태에서 새 배송지 추가 시 기본배송지 여부 선택 가능하도록
          this.$refs.mbc011502.bassDvyaYnDisabled = false
        }
        this.assignNotNull(this.$refs.mbc011502.form, this.$refs.mbc011502.$options.data().form)
        this.$refs.mbc011502.form.action = 'ins'
        this.$refs.mbc011502.outerVisible = true
        if (this.srcComp !== '') {
          this.$refs.mbc011502.srcComp = this.srcComp
        }
      }
    },
    dvyaUpdt (idx) {
      this.assignNotNull(this.$refs.mbc011502.form, this.list[idx])
      this.$refs.mbc011502.bassDvyaYnDisabled = this.list[idx].bassDvyaYn === 'Y'
      this.$refs.mbc011502.form.action = 'upd'
      this.$refs.mbc011502.outerVisible = true
      if (this.srcComp !== '') {
        this.$refs.mbc011502.srcComp = this.srcComp
      }
    },
    dvyaDel (item) {
      this.$confirm(this.$t('SM.DELETE_DELIVERY_CONFIRM'), '', {
        cancelButtonText: '아니오',
        confirmButtonText: '예',
        dangerouslyUseHTMLString: true
      }).then(async () => {
        await this.$AxiosBuilder
          .data(item)
          .build()
          .post('/mb/mbc/upDvyaUseYn')
          .then((res) => {
            console.log(res)
            if (this.isNotEmpty(res.data.data)) {
              const data = res.data.data
              if (res.data.success) {
                if (item.bassDvyaYn === 'Y' && this.list.length > 1) {
                  this.bassDvyaUpdt(this.list[1])
                }
                this.dvyaList()
              } else {
                this.$alert(data, '', {
                  confirmButtonText: '확인', /* 확인 */
                  dangerouslyUseHTMLString: true
                })
              }
            }
          })
          .catch((err) => {
            console.log('error')
            console.log(err)
          })
      }).catch(() => {
        // 취소버튼
      })
    },
    bassDvyaUpdt (item) {
      const data = item || this.list[this.selIdx]
      this.$AxiosBuilder
        .data(data)
        .build()
        .post('/mb/mbc/upBassDvya')
        .then((res) => {
          console.log(res)
          if (this.isNotEmpty(res.data.data)) {
            if (res.data.success) {
              this.dvyaList()
              this.$emit('getData', data)
            } else {
              this.$alert(data, '', {
                confirmButtonText: '확인', /* 확인 */
                dangerouslyUseHTMLString: true
              })
            }
          }
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        })
    },
    selPosiStr () {
      const copyList = this.list
      copyList?.forEach((item, index) => {
        this.selPosiStrInfo(item?.addrZip).then((response) => {
          if (!response?.strLgctCntrCd) {
            item.ableDlv = true
            this.list.splice(index, 1, item)
          } else {
            item.ableDlv = false
            this.list.splice(index, 1, item)
          }
        })
      })
    },
    selPosiStrInfoList (zipList) { // 거점매장리스트 조회
      this.$AxiosBuilder
        .data(zipList)
        .build()
        .post('/dl/dla-api/selPosiStrInfoList')
        .then((res) => {
          if (this.isNotEmpty(res.data.data)) {
            const resData = res.data.data
            this.posiStrInfoList = resData
          }
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        })
    },
    selPosiQuickStrInfoList (zipList) { // 오늘배송매장리스트 조회
      this.$AxiosBuilder
        .data(zipList)
        .build()
        .post('/dl/dla-api/selPosiQuickStrInfoList')
        .then((res) => {
          if (this.isNotEmpty(res.data.data)) {
            const resData = res.data.data
            this.posiQuickStrInfoList = resData
          }
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        })
    },
    selRecentDvya () { // 최근배송지조회
      const param = {
        orNo: '',
        dlvFomCd: '',
        gfYn: '',
        status: '',
        currentPageCnt: 1,
        strtDt: dayjs().month(dayjs().month() - 12).format('YYYYMMDD'),
        endDt: dayjs().format('YYYYMMDD'),
        orStsCd: '',
        rowNumber: '',
        currentPage: 1, // 페이지 번호 현재 페이지 번호를 나타냄
        pageSize: 1, // 페이지 사이즈 기본 10
        orTyCd: this.tabIdx === '1' ? '00' : '02' // 주문 유형 (06 - 매장픽업, 상품권 제외)
      }
      this.$AxiosBuilder
        .data(param)
        .build()
        .post('/or/orb/selOr')
        .then(async (res) => {
          const result = res.data
          if (result.success) {
            const recentDvya = await this.callApi('/or/orb/orDts/selOrDtl', { orNo: result.data[0].orNo })
            this.recentDvya = recentDvya
          }
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        })
    },
    selGeolocationAgrYn () {
      this.selGeolocation()
      this.srchForm.geolocationAgrYn = this.geoData.geolocationAgrYn
      this.srchForm.curLttd = this.geoData.strLttd
      this.srchForm.curLitd = this.geoData.strLitd
    },

    selPkupStrList () {
      this.$AxiosBuilder
        .data(this.srchForm)
        .build()
        .post('/mb/mbc/selPkupStrList')
        .then((res) => {
          if (this.isNotEmpty(res.data.data)) {
            this.pkupStrList = res.data.data
            const currentTime = this.getCurrentTime()
            this.$EventBus.$emit('intTotalCnt', this.pkupStrList[0]?.totalCnt, this.pkupStrList[0]?.intCnt)
            this.pkupStrList.forEach((item) => {
              if (!_.isEmpty(item.opngTime) && !_.isEmpty(item.clsngTime) && _.isEmpty(item.hldyDt)) {
                if (currentTime >= item.opngTime && currentTime <= item.clsngTime) {
                  item.status = 'status'
                } else {
                  item.status = 'off'
                }
              } else if (!_.isEmpty(item.hldyDt)) {
                item.status = 'close'
              }
            })
          }
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        })
    },
    upBassPkupStrYn (item, type) {
      if (this.isNotEmpty(item)) {
        this.$AxiosBuilder
          .data(item)
          .build()
          .post('/mb/mbc/upBassPkupStr')
          .then((res) => {
            if (this.isNotEmpty(res.data.data)) {
              this.$emit('getStoreData', item)
              this.addStoreVisible = false
              this.selPkupStrList()
            }
          })
          .catch((err) => {
            console.log('error')
            console.log(err)
          })
      }
    },
    delPkupStr (item) {
      this.$AxiosBuilder
        .data(item)
        .build()
        .post('/mb/mbc/delPkupStr')
        .then((res) => {
          if (this.isNotEmpty(res.data.data)) {
            if (res.data.success) {
              if (item.bassPkupStrYn === 'Y' && this.pkupStrList.length > 1) {
                this.upBassPkupStrYn(this.pkupStrList[1], 'del')
              }
              this.selPkupStrList()
            }
          }
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        })
    },
    async callApi (url, params) {
      return await this.$AxiosBuilder
        .data(params)
        .build()
        .post(url)
        .then((res) => {
          return res.data.data
        })
    },
    setDvya (item) {
      this.bassDvyaUpdt(item)
    },

    addStore (item, idx) {
      this.upBassPkupStrYn(item)
    },

    getCurrentTime () {
      const now = new Date()
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      return `${hours}:${minutes}`
    },
  }
}
